import { render, staticRenderFns } from "./InvoiceTeamFields.vue?vue&type=template&id=3963f527&"
import script from "./InvoiceTeamFields.vue?vue&type=script&lang=js&"
export * from "./InvoiceTeamFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports